const black = '#000000';
const yellow = '#E5D055';
const greyBlue = '#94C3C5';
const orange = '#E28E54';
const blue = '#41A5F7';
const red = '#C44B46';
const pink = '#EDCBD4';
const darkGrey = '#788F76';

export function IconTrash() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M9,10 C10.7170207,10 20.7170207,10 39,10 L29.964325,45.8249474 L14.738,43 C15.2921121,41.1001994 15.0263341,39.6252493 13.9406662,38.5751495 C12.8549983,37.5250498 11.2081095,37 9,37"
          fill={greyBlue}
        ></path>
        <g
          transform="translate(6.000000, 1.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M0,40.4999999 C0,42.1076952 0.857695125,43.5932668 2.24999998,44.3971144 C3.64230484,45.200962 5.35769516,45.200962 6.75000002,44.3971144 C8.14230487,43.5932668 9,42.1076952 9,40.4999999 C9,38.8923048 8.14230487,37.4067332 6.75000002,36.6028856 C5.35769516,35.799038 3.64230484,35.799038 2.24999998,36.6028856 C0.857695125,37.4067332 0,38.8923048 0,40.4999999"></path>
          <polyline points="8.738 42 24 45 33 9 3 9 3 36.256"></polyline>
          <path d="M27,0 L6,0 C4.34314575,0 3,1.34314575 3,3 L3,9 L36,9 C36,4.02943725 31.9705627,0 27,0 Z"></path>
        </g>
      </g>
    </svg>
  );
}

export function IconUserReactivate() {
  return (
    <svg width="47" height="47" viewBox="0 0 47 47">
      <g transform="translate(-10219 -8972)">
        <g>
          <g transform="translate(61)">
            <path
              d="M10.674,42.252,18,45.862l11,1.112,9.326-4.722q-4.312-3.509-4.687-3.509c-.375,0-7.461-2.243-7.461-2.243L21,37.285l-5.548,1.458Z"
              transform="translate(10157 8971)"
              fill={yellow}
              fillRule="evenodd"
            />
            <g transform="translate(10159 8973)">
              <path
                d="M13.452,12.668A17.422,17.422,0,0,0,26,18a17.45,17.45,0,0,0,6.9-1.42"
                fill="none"
                stroke={black}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                fillRule="evenodd"
              />
              <path
                d="M12,18A10.5,10.5,0,1,0,22.5,7.5,10.5,10.5,0,0,0,12,18"
                fill="none"
                stroke={black}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                fillRule="evenodd"
              />
              <path
                d="M36.326,40.252a19.492,19.492,0,0,0-27.652,0"
                fill="none"
                stroke={black}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                fillRule="evenodd"
              />
              <path
                d="M0,22.5A22.5,22.5,0,1,0,22.5,0,22.5,22.5,0,0,0,0,22.5"
                fill="none"
                stroke={black}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                fillRule="evenodd"
              />
            </g>
          </g>
          <g transform="translate(1 1)">
            <g
              transform="translate(10248 9000)"
              fill="#fff"
              stroke={black}
              strokeWidth="2"
            >
              <rect width="16" height="16" rx="8" stroke="none" />
              <rect x="1" y="1" width="14" height="14" rx="7" fill="none" />
            </g>
            <g transform="translate(10251 9002)">
              <g transform="translate(1 3)">
                <path
                  d="M3.082.5A.505.505,0,0,0,2.735.035a.58.58,0,0,0-.6.126L.145,2.142a.473.473,0,0,0,0,.681L2.134,4.8a.58.58,0,0,0,.6.126.505.505,0,0,0,.347-.467V3.488H5.267A2.63,2.63,0,0,1,8,6V3.991A2.63,2.63,0,0,0,5.267,1.478H3.081Z"
                  transform="translate(0 0)"
                  fillRule="evenodd"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconUserDeactivate() {
  return (
    <svg width="47" height="47" viewBox="0 0 47 47">
      <g transform="translate(-10078 -9070)">
        <g transform="translate(-80 98)">
          <path
            d="M10.674,42.252,18,45.862l11,1.112,9.326-4.722q-4.312-3.509-4.687-3.509c-.375,0-7.461-2.243-7.461-2.243L21,37.285l-5.548,1.458Z"
            transform="translate(10157 8971)"
            fill={yellow}
            fillRule="evenodd"
          />
          <g transform="translate(10159 8973)">
            <path
              d="M13.452,12.668A17.422,17.422,0,0,0,26,18a17.45,17.45,0,0,0,6.9-1.42"
              fill="none"
              stroke={black}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              fillRule="evenodd"
            />
            <path
              d="M12,18A10.5,10.5,0,1,0,22.5,7.5,10.5,10.5,0,0,0,12,18"
              fill="none"
              stroke={black}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              fillRule="evenodd"
            />
            <path
              d="M36.326,40.252a19.492,19.492,0,0,0-27.652,0"
              fill="none"
              stroke={black}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              fillRule="evenodd"
            />
            <path
              d="M0,22.5A22.5,22.5,0,1,0,22.5,0,22.5,22.5,0,0,0,0,22.5"
              fill="none"
              stroke={black}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              fillRule="evenodd"
            />
          </g>
        </g>
        <g transform="translate(1 1)">
          <g
            transform="translate(10107 9098)"
            fill="#fff"
            stroke={black}
            strokeWidth="2"
          >
            <rect width="16" height="16" rx="8" stroke="none" />
            <rect x="1" y="1" width="14" height="14" rx="7" fill="none" />
          </g>
          <g transform="translate(-81.949 96.051)">
            <line
              x2="8.898"
              y2="8.898"
              transform="translate(10192.5 9005.5)"
              fill="none"
              stroke={black}
              strokeLinecap="round"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconClock() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle fill={orange} cx="36" cy="34" r="12"></circle>
        <g
          transform="translate(3.000000, 1.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M15,33 L3,33 C1.34314575,33 0,31.6568542 0,30 L0,6 C0,4.34314575 1.34314575,3 3,3 L30,3 C31.6568542,3 33,4.34314575 33,6 L33,15"></path>
          <line x1="0" y1="12" x2="33" y2="12"></line>
          <line x1="9" y1="6" x2="9" y2="0"></line>
          <line x1="24" y1="6" x2="24" y2="0"></line>
          <path d="M21,33 C21,39.627417 26.372583,45 33,45 C39.627417,45 45,39.627417 45,33 C45,26.372583 39.627417,21 33,21 C26.372583,21 21,26.372583 21,33"></path>
          <polyline points="38.304 33 33 33 33 27.698"></polyline>
        </g>
      </g>
    </svg>
  );
}

export function IconWarning() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon
          fill={red}
          points="32.8501951 22 34.9333163 22 46.00246 41 44.0180041 46 24.3479359 46.0012825 21.00246 42.4999998"
        ></polygon>
        <g
          transform="translate(1.000000, 1.000000)"
          stroke={black}
          strokeWidth="2"
        >
          <path d="M33,40.5 C32.5857864,40.5 32.25,40.1642136 32.25,39.75 C32.25,39.3357864 32.5857864,39 33,39"></path>
          <path d="M33,40.5 C33.4142136,40.5 33.75,40.1642136 33.75,39.75 C33.75,39.3357864 33.4142136,39 33,39"></path>
          <line
            x1="33"
            y1="34.5"
            x2="33"
            y2="28.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></line>
          <path
            d="M44.626,39.864 C45.1777882,40.9639458 45.119849,42.2713283 44.4729226,43.3181507 C43.8259961,44.3649731 42.6825887,45.0015465 41.452,45.0000028 L24.548,45.0000028 C23.3183288,44.9993003 22.1765947,44.3622925 21.530151,43.3162513 C20.8837073,42.2702101 20.8246311,40.9641298 21.374,39.864 L29.826,22.962 C30.4267752,21.7593649 31.6556555,20.9995687 33,20.9995687 C34.3443445,20.9995687 35.5732248,21.7593649 36.174,22.962 L44.626,39.864 L44.626,39.864 Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M13.5,39 L3,39 C1.34314575,39 0,37.6568542 0,36 L0,3 C0,1.34314575 1.34314575,0 3,0 L24.258,0 C25.0530944,0 25.8156032,0.315963504 26.378,0.878 L32.122,6.622 C32.6840365,7.18439678 33,7.94690558 33,8.742 L33,15"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path d="M9,11.25 C8.58578644,11.25 8.25,10.9142136 8.25,10.5 C8.25,10.0857864 8.58578644,9.75 9,9.75"></path>
          <path d="M9,11.25 C9.41421356,11.25 9.75,10.9142136 9.75,10.5 C9.75,10.0857864 9.41421356,9.75 9,9.75"></path>
          <path
            d="M24.212,20.14 L21,15 C20.7256596,14.5872789 20.2649533,14.3369512 19.7694032,14.3312512 C19.273853,14.3257433 18.8076036,14.5655885 18.524,14.972 L14.524,20.672 L12.06,18.7 C11.7318242,18.4369443 11.3082838,18.3237536 10.892631,18.388022 C10.4769783,18.4522903 10.1074024,18.6881129 9.874,19.038 L6,26.998 L18,26.998"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export function IconAvatar() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M10.674,42.252 L18,45.8616867 L29,46.9741464 L38.326,42.252 C35.4513333,39.9126641 33.889,38.7429962 33.639,38.7429962 C33.264,38.7429962 26.1776886,36.4997157 26.1776886,36.4997157 C26.1776886,36.4997157 24.4517924,36.76143 21,37.2848587 L15.452,38.7429962 L10.674,42.252 Z"
          fill={darkGrey}
        />
        <g
          transform="translate(2.000000, 2.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M13.452,12.668 C16.7366866,16.0760979 21.2666823,18.0010211 26,18.0000007 C28.3726189,18.0006739 30.7204538,17.5174963 32.9,16.58" />
          <path d="M12,18 C12,23.7989899 16.7010101,28.5 22.5,28.5 C28.2989899,28.5 33,23.7989899 33,18 C33,12.2010101 28.2989899,7.5 22.5,7.5 C16.7010101,7.5 12,12.2010101 12,18" />
          <path d="M36.326,40.252 C32.6670956,36.570118 27.6907452,34.4997157 22.5,34.4997157 C17.3092548,34.4997157 12.3329044,36.570118 8.674,40.252" />
          <path d="M0,22.5 C0,34.9264069 10.0735931,45 22.5,45 C34.9264069,45 45,34.9264069 45,22.5 C45,10.0735931 34.9264069,0 22.5,0 C10.0735931,0 0,10.0735931 0,22.5" />
        </g>
      </g>
    </svg>
  );
}

export function IconRank() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle fill={pink} cx="25" cy="34" r="14" />
        <g
          transform="translate(2.000000, 1.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M9,32.5 C9,39.9558441 15.0441559,46 22.5,46 C29.9558441,46 36,39.9558441 36,32.5 C36,25.0441559 29.9558441,19 22.5,19 C15.0441559,19 9,25.0441559 9,32.5"></path>
          <polyline points="10.2 26.92 0 10 8 1 17.98 19.78" />
          <path d="M19.5,26.5 L21,26.5 C21.8239241,26.5107716 22.4892284,27.1760759 22.5,28 L22.5,38.5"></path>
          <line x1="19.5" y1="38.5" x2="25.5" y2="38.5" />
          <polyline points="34.8 26.92 45 10 37 1 27.02 19.78" />
          <line x1="37" y1="1" x2="8" y2="1" />
        </g>
      </g>
    </svg>
  );
}

export function IconLogout() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon
          fill={pink}
          points="4 7.0502739 22.1800889 2.03454617 24.0000889 3.49454617 24 46.1991882 22.1800889 46.9741464 4.28008886 44.4745462 3 42.9745462 3 7.97454617"
        />
        <g
          transform="translate(3.000000, 2.000000)"
          stroke={black}
          strokeWidth="2"
        >
          <path
            d="M39.0000889,35.9745462 L39.0000889,38.9745462 C39.0000889,40.6314004 37.6569431,41.9745462 36.0000889,41.9745462 L27.0000889,41.9745462"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.0000889,5.97454617 L36.0000889,5.97454617 C37.6569431,5.97454617 39.0000889,7.31769192 39.0000889,8.97454617 L39.0000889,11.9745462"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.2800889,44.9545462 L1.28008886,42.4745462 C0.538542309,42.3646417 -0.0080113502,41.7241492 1.77635684e-15,40.9745462 L1.77635684e-15,5.91454617 C0.0119226381,5.21899486 0.500429198,4.62285127 1.18008886,4.47454617 L19.1800889,0.0345461721 C19.6227139,-0.0621086322 20.085311,0.0464707082 20.4387086,0.329965447 C20.7921061,0.613460185 20.9984376,1.04149389 21.0000889,1.49454617 L21.0000889,43.4945462 C21.0000889,43.9289375 20.8090165,44.3413434 20.4778467,44.6224526 C20.1466769,44.9035619 19.7087307,45.024988 19.2800889,44.9545462 L19.2800889,44.9545462 Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            strokeLinecap="round"
            strokeLinejoin="round"
            points="39.0000889 17.9745462 45.0000889 23.9745462 28.5000889 23.9745462"
          />
          <line
            x1="39.0000889"
            y1="29.9745462"
            x2="45.0000889"
            y2="23.9745462"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M13.2500889,23.1625462 C12.8358753,23.1625462 12.5000889,22.8267597 12.5000889,22.4125462 C12.5000889,21.9983326 12.8358753,21.6625462 13.2500889,21.6625462" />
          <path d="M13.2500889,23.1625462 C13.6643024,23.1625462 14.0000889,22.8267597 14.0000889,22.4125462 C14.0000889,21.9983326 13.6643024,21.6625462 13.2500889,21.6625462" />
        </g>
      </g>
    </svg>
  );
}

export function IconPassword() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(2.000000, 2.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M0,38.9999998 C0,42.3137083 2.6862915,44.9999998 6,44.9999998 C9.3137085,44.9999998 12,42.3137083 12,38.9999998 C12,35.6862913 9.3137085,32.9999998 6,32.9999998 C2.6862915,32.9999998 0,35.6862913 0,38.9999998"></path>
          <polyline points="12 38.9999998 27 38.9999998 27 43.4999998" />
          <line x1="21" y1="38.9999998" x2="21" y2="41.9999998" />
          <path d="M12,28.4999998 L12,20.9999998 C12,19.3431456 13.3431458,17.9999998 15,17.9999998 L42,17.9999998 C43.6568542,17.9999998 45,19.3431456 45,20.9999998 L45,41.9999998 C45,43.6568541 43.6568542,44.9999998 42,44.9999998 L33,44.9999998"></path>
          <path d="M18,18 L18,10.5 C18,4.70101003 22.7010102,0 28.5,0 C34.2989898,0 39,4.70101003 39,10.5 L39,18" />
          <line x1="28.5" y1="26.9999998" x2="28.5" y2="32.9999998" />
        </g>
        <circle fill={red} cx="8" cy="41" r="5" />
      </g>
    </svg>
  );
}

export function IconSystemMessages() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M33.5,1 C40.4035594,1 46,6.59644063 46,13.5 C46,20.4035594 40.4035594,26 33.5,26 C31.7195777,26 30.0260944,25.6277696 28.4931266,24.9568852 C26.8282721,27.1053703 21.44174,27.6484058 18.4012036,26.159369 C16.8591277,25.4041707 20.1233347,21.0189724 22.0837479,18.5958925 C21.3870065,17.0404426 21,15.3154164 21,13.5 C21,6.59644063 26.5964406,1 33.5,1 Z"
          fill={blue}
        />
        <g
          transform="translate(1.000000, 1.000000)"
          stroke={black}
          strokeWidth="2"
        >
          <line
            x1="42"
            y1="30.0012825"
            x2="42"
            y2="36.0012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3,36.0012825 L3,15.0012825 C3,13.3444282 4.34314575,12.0012825 6,12.0012825 L13.5,12.0012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.668,36.0012825 C26.6083476,37.8559903 24.6360722,39.000643 22.5,39.000643 C20.3639278,39.000643 18.3916524,37.8559903 17.332,36.0012825 L0,36.0012825 L0,39.0012825 C0,42.314991 2.6862915,45.0012825 6,45.0012825 L39,45.0012825 C42.3137085,45.0012825 45,42.314991 45,39.0012825 L45,36.0012825 L27.668,36.0012825 Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(16.540000, 0.000000)">
            <path
              d="M19.29,0.533282491 C14.4827775,-0.903250388 9.28017773,0.618810461 6.00524483,4.41984048 C2.73031192,8.22087049 1.99435867,13.5913534 4.126,18.1332825 L0,26.5132825 L9.444,23.9332825 C13.7242131,26.3228663 18.9944431,26.051827 23.0069383,23.2357629 C27.0194336,20.4196987 29.066115,15.5555563 28.2740737,10.717891 C27.4820323,5.88022571 23.9910384,1.92273303 19.29,0.533282491 L19.29,0.533282491 Z"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M15.724,18.0752825 C15.3097864,18.0752825 14.974,17.7394961 14.974,17.3252825 C14.974,16.9110689 15.3097864,16.5752825 15.724,16.5752825"></path>
            <path d="M15.724,18.0752825 C16.1382136,18.0752825 16.474,17.7394961 16.474,17.3252825 C16.474,16.9110689 16.1382136,16.5752825 15.724,16.5752825"></path>
            <line
              x1="15.724"
              y1="12.0752825"
              x2="15.724"
              y2="6.07528249"
              strokeLinecap="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function IconSearch() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle fill={yellow} cx="32" cy="32" r="10"></circle>
        <g
          transform="translate(5.000000, 5.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M8.5,0 L11.5,0 C11.5,0 13,0 13,1.5 L13,7.5 C13,7.5 13,9 11.5,9 L8.5,9 C8.5,9 7,9 7,7.5 L7,1.5 C7,1.5 7,0 8.5,0"></path>
          <path d="M26.5,0 L29.5,0 C29.5,0 31,0 31,1.5 L31,7.5 C31,7.5 31,9 29.5,9 L26.5,9 C26.5,9 25,9 25,7.5 L25,1.5 C25,1.5 25,0 26.5,0"></path>
          <line x1="1" y1="0" x2="1" y2="9" />
          <line x1="19" y1="0" x2="19" y2="9" />
          <line x1="37" y1="0" x2="37" y2="9" />
          <line x1="12" y1="15" x2="12" y2="21" />
          <path d="M2.5,15 L5.5,15 C5.5,15 7,15 7,16.5 L7,22.5 C7,22.5 7,24 5.5,24 L2.5,24 C2.5,24 1,24 1,22.5 L1,16.5 C1,16.5 1,15 2.5,15"></path>
          <path d="M16.5,26.9999998 C16.5,30.7512887 18.5012886,34.2176225 21.75,36.0932669 C24.9987113,37.9689113 29.0012887,37.9689113 32.25,36.0932669 C35.4987114,34.2176225 37.5,30.7512887 37.5,26.9999998 C37.5,23.2487113 35.4987114,19.7823775 32.25,17.9067331 C29.0012887,16.0310887 24.9987113,16.0310887 21.75,17.9067331 C18.5012886,19.7823775 16.5,23.2487113 16.5,26.9999998"></path>
          <line x1="42" y1="42" x2="34.424" y2="34.426" />
        </g>
      </g>
    </svg>
  );
}

export function IconSafe() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect fill={orange} x="10" y="8" width="31" height="30" rx="4" />
        <g
          transform="translate(1.000000, 2.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M3,0 L42,0 C42,0 45,0 45,3 L45,39 C45,39 45,42 42,42 L3,42 C3,42 0,42 0,39 L0,3 C0,3 0,0 3,0" />
          <path d="M12,6 L36,6 C36,6 39,6 39,9 L39,33 C39,33 39,36 36,36 L12,36 C12,36 9,36 9,33 L9,9 C9,9 9,6 12,6" />
          <line x1="6" y1="42" x2="6" y2="45" />
          <line x1="39" y1="42" x2="39" y2="45" />
          <line x1="6" y1="15" x2="12" y2="15" />
          <line x1="6" y1="27" x2="12" y2="27" />
          <path d="M18.6,21 C18.6,23.9823376 21.0176624,26.4 24,26.4 C26.9823376,26.4 29.4,23.9823376 29.4,21 C29.4,18.0176624 26.9823376,15.6 24,15.6 C21.0176624,15.6 18.6,18.0176624 18.6,21" />
          <line x1="24" y1="15.6" x2="24" y2="12" />
          <line x1="24" y1="30" x2="24" y2="26.4" />
          <line x1="29.4" y1="21" x2="33" y2="21" />
          <line x1="15" y1="21" x2="18.6" y2="21" />
          <line x1="18.472" y1="27.364" x2="20.622" y2="25.214" />
          <line x1="18.472" y1="14.636" x2="20.622" y2="16.786" />
          <line x1="29.528" y1="27.364" x2="27.378" y2="25.214" />
          <line x1="29.528" y1="14.636" x2="27.378" y2="16.786" />
        </g>
      </g>
    </svg>
  );
}

export function IconMyAds() {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M25.8342247,8.28646088 C26.2605604,4.30655797 28.3158188,2.21107101 32,2 C35.6841812,1.78892899 37.7218463,3.96411769 38.1129951,8.5255661 C41.0747999,7.23521176 43.5190099,7.72504813 45.4456253,9.99507523 C48.3355484,13.4001159 46.6279984,18.9807281 41.9385948,20.2243347 L42.0722542,20.4719734 C43.7497164,24.0635618 43.3959859,26.9981753 41.0110626,29.2758141 C38.6261393,31.5534528 35.6971067,31.0129089 32.2239647,27.6541824 C30.0556196,30.6152344 26.9762058,31.1557782 22.9857235,29.2758141 C18.9952412,27.3958499 19.0475229,24.2498137 23.1425686,19.8377056 C18.5873432,19.2981968 16.5398204,17.0943273 17,13.2260971 C17.4601796,9.35786692 20.4049212,7.71132151 25.8342247,8.28646088 Z"
          fill={greyBlue}
        />
        <circle fill="#FFFFFF" cx="32" cy="17" r="4" />
        <g
          transform="translate(1.000000, 2.000000)"
          stroke={black}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M46.0000967,12 C46.0123122,9.831724 44.8480124,7.82724162 42.9584764,6.76365053 C41.0689404,5.70005945 38.7512778,5.7445982 36.904,6.88 C36.9564353,6.58939636 36.9865234,6.29520168 36.994,6 C36.994,2.6862915 34.3077085,1.77635684e-15 30.994,1.77635684e-15 C27.6802915,1.77635684e-15 24.994,2.6862915 24.994,6 C25.0008161,6.29515028 25.0302355,6.58934456 25.082,6.88 C22.93116,5.58086353 20.1979052,5.76328301 18.238783,7.33672144 C16.2796608,8.91015988 15.5117379,11.5396566 16.3161437,13.9201607 C17.1205496,16.3006647 19.3260386,17.9254037 21.838,17.988 C20.0181126,19.5521345 19.3099177,22.0529119 20.0394561,24.3390179 C20.7689945,26.625124 22.7948509,28.2534155 25.1843565,28.4742555 C27.573862,28.6950954 29.8638304,27.4656758 31,25.352 C32.1332007,27.472282 34.4259527,28.7077987 36.8200192,28.488288 C39.2140858,28.2687774 41.2439303,26.6369243 41.9726628,24.3459226 C42.7013953,22.054921 41.9873107,19.5502661 40.16,17.988 C43.4064053,17.9014028 45.9946597,15.2475557 46.0000967,12 L46.0000967,12 Z"></path>
          <line x1="1" y1="26.776" x2="1" y2="44.776" />
          <path d="M31,41.776 C31,38.4622915 28.3137085,35.776 25,35.776 L17.504,35.776 C17.504,32.4622915 14.8177085,29.776 11.504,29.776 L1,29.776 L1,41.776 L31,41.776 Z"></path>
          <line x1="11.5" y1="35.776" x2="17.5" y2="35.776" />
          <path d="M26.5,14.776 C26.5,16.3836952 27.3576951,17.8692668 28.75,18.6731144 C30.1423048,19.476962 31.8576952,19.476962 33.25,18.6731144 C34.6423049,17.8692668 35.5,16.3836952 35.5,14.776 C35.5,12.2907186 33.4852814,10.276 31,10.276 C28.5147186,10.276 26.5,12.2907186 26.5,14.776"></path>
        </g>
      </g>
    </svg>
  );
}

function IconMessagesFill({ fill }: { fill: string }) {
  return (
    <svg width="48px" height="48px" viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M33.5,1 C40.4035594,1 46,6.59644063 46,13.5 C46,20.4035594 40.4035594,26 33.5,26 C31.7195777,26 30.0260944,25.6277696 28.4931266,24.9568852 C26.8282721,27.1053703 21.44174,27.6484058 18.4012036,26.159369 C16.8591277,25.4041707 20.1233347,21.0189724 22.0837479,18.5958925 C21.3870065,17.0404426 21,15.3154164 21,13.5 C21,6.59644063 26.5964406,1 33.5,1 Z"
          fill={fill}
        />
        <g
          transform="translate(1.000000, 1.000000)"
          stroke={black}
          strokeWidth="2"
        >
          <line
            x1="42"
            y1="30.0012825"
            x2="42"
            y2="36.0012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3,36.0012825 L3,15.0012825 C3,13.3444282 4.34314575,12.0012825 6,12.0012825 L13.5,12.0012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.668,36.0012825 C26.6083476,37.8559903 24.6360722,39.000643 22.5,39.000643 C20.3639278,39.000643 18.3916524,37.8559903 17.332,36.0012825 L0,36.0012825 L0,39.0012825 C0,42.314991 2.6862915,45.0012825 6,45.0012825 L39,45.0012825 C42.3137085,45.0012825 45,42.314991 45,39.0012825 L45,36.0012825 L27.668,36.0012825 Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.632,0.533282491 C30.8247775,-0.903250388 25.6221777,0.618810461 22.3472448,4.41984048 C19.0723119,8.22087049 18.3363587,13.5913534 20.468,18.1332825 L16.34,26.5132825 L25.786,23.9332825 C26.62,24.4092825 27.506,24.7892825 28.424,25.0652825 C32.8313996,26.4345875 37.6346803,25.3220183 40.9912017,22.1543802 C44.3477231,18.9867421 45.7363189,14.2558735 44.6242942,9.77663607 C43.5122694,5.29739861 40.0722881,1.76528252 35.624,0.535282491 L35.632,0.535282491 L35.632,0.533282491 Z"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M37.5,9.00128249 C37.0857864,9.00128249 36.75,8.66549605 36.75,8.25128249 C36.75,7.83706893 37.0857864,7.50128249 37.5,7.50128249" />
          <path d="M37.5,9.00128249 C37.9142136,9.00128249 38.25,8.66549605 38.25,8.25128249 C38.25,7.83706893 37.9142136,7.50128249 37.5,7.50128249" />
          <line
            x1="25.5"
            y1="9.00128249"
            x2="25.5"
            y2="18.0012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="37.5"
            y1="13.5012825"
            x2="37.5"
            y2="18.0012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="25.5"
            y1="13.5012825"
            x2="31.5"
            y2="13.5012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="31.5"
            y1="9.00128249"
            x2="31.5"
            y2="18.0012825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}

export function IconMessages() {
  return <IconMessagesFill fill={yellow} />;
}

export function IconChat() {
  return <IconMessagesFill fill={blue} />;
}

export function IconPreferences() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48">
      <g transform="translate(4364.684 769)">
        <path
          d="M7.893,24.016a1.984,1.984,0,0,1-.821-.177,2.108,2.108,0,0,1-1.3-2v-1.5a2,2,0,0,0-1.986-2.219h-1.6a2.115,2.115,0,0,1-1.955-1.3,2.01,2.01,0,0,1,.52-2.338l1.119-1a2.118,2.118,0,0,0,0-3.118L.716,9.51A2,2,0,0,1,.2,7.112a2.113,2.113,0,0,1,1.952-1.3H3.695a2,2,0,0,0,2.218-2.1v-1.5a2.107,2.107,0,0,1,1.3-2A2,2,0,0,1,9.55.736l.979,1.08a2.12,2.12,0,0,0,3.118,0l1-1.12A2,2,0,0,1,16.984.177a2.106,2.106,0,0,1,1.3,2v1.5a2,2,0,0,0,1.988,2.187c.063,0,.127,0,.19-.009h1.544a2.114,2.114,0,0,1,1.954,1.3A2,2,0,0,1,23.34,9.51l-1.12,1a2.118,2.118,0,0,0,0,3.118l1.12,1a2.01,2.01,0,0,1,.519,2.338,2.113,2.113,0,0,1-1.953,1.3H20.362a2.015,2.015,0,0,0-.219-.012,2,2,0,0,0-2,2.05v1.5a2.1,2.1,0,0,1-1.3,2,2,2,0,0,1-2.318-.48l-1-1.119a2.118,2.118,0,0,0-3.118,0l-1,1.119A2,2,0,0,1,7.893,24.016ZM12.029,8.51a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,12.029,8.51Z"
          transform="translate(-4363.615 -747.016)"
          fill="transparent"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M16,24.136a2,2,0,0,1-1.517-.7l-1-1.12a2.118,2.118,0,0,0-3.118,0l-1,1.12a2,2,0,0,1-2.338.519,2.108,2.108,0,0,1-1.3-2v-1.5a2,2,0,0,0-1.97-2.339H2.171a2.112,2.112,0,0,1-1.954-1.3A1.99,1.99,0,0,1,.7,14.506l1.119-1a2.118,2.118,0,0,0,0-3.118L.7,9.39a2.01,2.01,0,0,1-.52-2.338,2.115,2.115,0,0,1,1.955-1.3H3.674A2,2,0,0,0,5.892,3.714v-1.5a2.109,2.109,0,0,1,1.3-2A2,2,0,0,1,9.509.7l.94,1.12a2.12,2.12,0,0,0,3.118,0l1-1.12A2,2,0,0,1,16.9.177a2.106,2.106,0,0,1,1.3,2v1.5A2,2,0,0,0,20.188,5.9q.056,0,.113,0h1.544a2.114,2.114,0,0,1,1.954,1.3,2.01,2.01,0,0,1-.519,2.338l-1.12,1a2.118,2.118,0,0,0,0,3.118l1.12,1a2.01,2.01,0,0,1,.519,2.338,2.114,2.114,0,0,1-1.954,1.3H20.3c-.063-.006-.127-.009-.19-.009a2.011,2.011,0,0,0-1.412.585,1.991,1.991,0,0,0-.576,1.6v1.5a2.108,2.108,0,0,1-1.3,2A1.985,1.985,0,0,1,16,24.136ZM12.008,8.51a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,12.008,8.51Z"
          transform="translate(-4342.611 -768)"
          fill={pink}
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
